import React, { useReducer, useContext, createContext, useEffect, Dispatch } from "react";
import * as moment from "moment";
import { formatArrayFieldsFromStrapi } from "../utils/format";
import settings from "../../../settings";

const initialState = {
  searchResult: [],
  datePicked: null,
  allDayBestOf: [],
  postByDay: {
    saturday: [],
    sunday: [],
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
  },
  title: {
    text: 'Undifined',
    modify: 0,
    generate: false,
  },
  postCover: [],
  msgPostCover: "",
  isLoading: 0,
  isLoadingResearch: 0,
  isSave: true
};

interface PostByDay {
  saturday: Array<any>
  sunday: Array<any>
  monday: Array<any>
  tuesday: Array<any>
  wednesday: Array<any>
  thursday: Array<any>
  friday: Array<any>
  [key:string]: Array<any>
}

type TitleType =  {
  text: string,
  modify: number,
  generate: boolean,
}

type InitialStateType = {
  searchResult: Array<any>,
  datePicked: any,
  allDayBestOf: Array<any>,
  postByDay: PostByDay,
  title: TitleType,
  postCover: Array<any>,
  msgPostCover: string,
  isLoading: number,
  isLoadingResearch: number,
  isSave: boolean
}


const BestOfContext = createContext<{
  state: InitialStateType;
  dispatch: Dispatch<any>;
}>({
  state: initialState,
  dispatch: () => null
});

export function useBestOf() {
  return useContext(BestOfContext);
}


let queryBuilder = (date: string) => {
  let begin = moment.utc(date + " 00:00:00").toISOString();
  let end = moment.utc(date + " 23:59:59").toISOString();
  let query =
    settings.servingApi +
    `/decryptages?publish_date_gte=${begin}&publish_date_lte=${end}`
  return query;
};

const reducer = (state:any, action: any) => {
  let day;
  let array;
  switch (action.type) {
    case "GENERATE_WEEK_DAY":
      day = moment.utc().day() >= 5 ? 5 : -2;
      let weeks = [];
      for (let i = 0; i < 7; i++) {
        weeks.push(moment.utc().day(day + -i).format("YYYY-MM-DD"));
      }
      return {
        ...state,
        allDayBestOf: weeks.reverse(),
        isSave: false,
      };
    case "SET_WEEK_DAY":
      return {
        ...state,
        allDayBestOf: action.payload.daysBestOf,
      };
    case "ADD_ARTICLE_POST_DAY":
      day = action.payload.day.toLowerCase();
      array = state.postByDay[day].filter((postDay: any) => postDay.slug === action.payload.post.slug);
      if (array.length === 0) {
        return {
          ...state,
          postByDay: {
            ...state.postByDay,
            [day]:  [...state.postByDay[day], action.payload.post]
          },
          isSave: false,
        };
      } else {
        return state
      }
    case "REMOVE_ARTICLE_POST_DAY":
      day = action.payload.day.toLowerCase();
      return {
        ...state,
        postByDay: {
          ...state.postByDay,
          [day]: state.postByDay[day].filter((postDay: any) => postDay.slug !== action.payload.post.slug),
          isSave: false,
        }
      };
    case "CHANGE_ORDER_POST_DAY":
      day = action.payload.day.toLowerCase();
      return {
        ...state,
        postByDay: {
          ...state.postByDay,
          [day]: action.payload.newArray
        },
        isSave: false,
      };
      case "SET_ARTICLE_COVER":
        return {
          ...state,
          postCover: action.payload.postCover,
        }
      case "ADD_ARTICLE_COVER":
        console.log("ADD_ARTICLE_COVER, post: ", action.payload.post)
        array = state.postCover.filter((postDay: any) => postDay.slug === action.payload.post.slug);
        if (array.length === 0 && state.postCover.length < 4) {
          return {
            ...state,
            postCover: [...state.postCover, action.payload.post],
            msgPostCover: "",
            isSave: false,
          };
        } else {
          if (array.length > 0) {
            return {
              ...state,
              msgPostCover: 'Cet article a déjà été ajouté.'
            }
          } else if (state.postCover.length >= 4) {
            return {
              ...state,
              msgPostCover: 'Vous avez déjà 4 articles sélectionnés.'
            }
          }
        }
        return {...state}
      case "REMOVE_ARTICLE_COVER":
        return {
          ...state,
          postCover: state.postCover.filter((postDay: any) => postDay.slug !== action.payload.post.slug),
          msgPostCover: "",
          isSave: false,
        };
      case "CHANGE_ORDER_COVER":
        return {
          ...state,
          postCover: action.payload.newArray,
          msgPostCover: "",
          isSave: false,
        };
    case "SET_POST_DAY":
      return {
        ...state,
        postByDay: action.payload.postByDay,
        isSave: false,
      };
    case "SET_RESULT_RESEARCH":
      return {
        ...state,
        searchResult: action.payload.searchResult
      };
    case "UPDATE_DAY_PICKED":
      return {
        ...state,
        datePicked: action.payload.datePicked
      }
    case "UPDATE_LOADING":
      return {
        ...state,
        isLoading: action.payload.isLoading
      }
    case "UPDATE_LOADING_RESEARCH":
      return {
        ...state,
        isLoadingResearch: action.payload.isLoading
      }
    case "RESET_BEST_OF":
      return {
        ...initialState
      }
    case "MODIFY_TITLE_BEST_OF":
      return {
        ...state,
        title: {
          ...state.title,
          modify: action.payload.modify
        },
        isSave: false,
      }
    case "SET_TITLE_BEST_OF":
      return {
        ...state,
        title: {
          ...state.title,
          text: action.payload.title
        },
        isSave: false,
      }
    case "SET_BEST_OF_SAVE":
      return {
        ...state,
        isSave: action.payload.isSave,
      }
    case "UPDATE_TITLE_GENERATE":
      return {
        ...state,
        title: {
          ...state.title,
          generate: action.payload.generate
        },
      }
    default:
      return state;
  }
};

const BestOfProvider = ({ children }: any) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    if (state.datePicked) {
      let query = queryBuilder(state.datePicked);
      dispatch({type: 'UPDATE_LOADING_RESEARCH', payload: { isLoading: 2 }});
      fetch(query)
        .then(res => res.json())
        .then((data) => {
          console.log("Strapi Post: ", formatArrayFieldsFromStrapi(data))
          if (!data.message) {
            dispatch({type: "SET_RESULT_RESEARCH", payload: { searchResult: formatArrayFieldsFromStrapi(data) }});
            dispatch({type: 'UPDATE_LOADING_RESEARCH', payload: { isLoading: 0 }});
          }
        })
        .catch(err => {
          console.log(err)
          dispatch({type: 'UPDATE_LOADING_RESEARCH', payload: { isLoading: 0 }});
        })
    }
    return () => {};
  }, [state.datePicked]);

  return (
    <BestOfContext.Provider value={{ state, dispatch }}>
      {children}
    </BestOfContext.Provider>
  );
}

export default BestOfProvider;
